/**
 * Category Mappers
 *
 * Functions for mapping API responses to UI-friendly formats
 */

import type { Category } from '@hummii/shared-types';

/**
 * Enhance Category with image path
 *
 * @param category - Category data from API
 * @param imagePath - Optional image path for category
 * @returns Category object with image path
 */
export function enhanceCategoryWithImage(
  category: Category,
  imagePath?: string,
): Category {
  return {
    ...category,
    iconUrl: category.iconUrl || imagePath || null,
  };
}

/**
 * Map array of Categories with image paths
 *
 * @param categories - Array of categories from API
 * @returns Array of Category objects with image paths
 */
export function mapCategoriesToCardProps(
  categories: Category[],
): Category[] {
  return categories.map((category) => {
    const imagePath = getCategoryImagePath(category.slug);
    return enhanceCategoryWithImage(category, imagePath);
  });
}

/**
 * Generate image path for category based on slug
 *
 * @param slug - Category slug
 * @returns Image path for category
 */
export function getCategoryImagePath(slug: string): string {
  return `/images/categories/${slug}.jpg`;
}
